import type { ReactNode } from 'react';

/**
 * 编辑范围提示。
 *
 * ## 为什么这条提示是组件，不是一句 JSX
 *
 * 「全部保存」把两条保存路径合成一个动作之后，客户唯一还需要分清的事情只剩
 * 一件：**这次改动影响多大**。改正文只影响当前页，改页头页脚会影响所有页面和
 * 语言 —— 后者一保存就落到 `site_blocks`，前台立刻全站变样。
 *
 * 这句话说漏一次，客户就会以为"我只改了首页的页头"而实际上全站都变了；
 * 反过来把范围说过头，他连正文都不敢改。所以两种范围各自钉住，并且有测试
 * 盯着"全站生效"四个字没在改文案时被顺手删掉。
 *
 * 视觉上刻意不像报错（红）也不像成功（绿）：这是**范围说明**，不是状态。
 */
export function ScopeNote({
  scope,
  path,
  children,
}: {
  /** `page` 只影响当前页；`site` 影响整个站点 */
  scope: 'page' | 'site';
  /** 仅本页时用来点名是哪一页（`/about` 这种路径） */
  path?: string;
  children?: ReactNode;
}) {
  if (scope === 'site') {
    return (
      <div className="scope-note scope-note--site">
        <strong>全站生效</strong>
        <span>
          页头和页脚属于整个站点：这次改动会影响所有页面和语言，保存后立即对访客生效。
        </span>
      </div>
    );
  }
  return (
    <p className="scope-note">
      <strong>仅本页</strong>
      <span>
        这一段只出现在「{path ?? '当前页'}」上，不影响其他页面。
        {children}
      </span>
    </p>
  );
}
